<template>
  <div>
    <h5 class="page-title">基本信息</h5>
    <div class="store-info-box" v-loading.fullscreen.lock="fullscreenLoading">
      <el-descriptions v-model="shopInfo" style="padding-top: 10px">
        <!--      <el-descriptions-item class="des-item" label="店铺ID"-->
        <!--        >{{ shopInfo.id }}-->
        <!--        <el-divider></el-divider>-->
        <!--      </el-descriptions-item>-->
        <el-descriptions-item
          class="des-item"
          :label="shopOrStudioTag + '名称'"
        >
          <span v-if="!shopInfo.name">&nbsp;</span>
          {{ shopInfo.name }}
          <el-link
            class="edit-btn"
            @click="openDialog(operationType.editShopName)"
            :underline="false"
            type="primary"
          >
            修改
          </el-link>
          <el-divider></el-divider>
        </el-descriptions-item>
        <el-descriptions-item
          class="des-item"
          :label="shopOrStudioTag + 'logo'"
          :labelStyle="logoLabelStyle"
        >
          <el-image
            id="logoImg"
            style="
              min-height: 192px;
              min-width: 192px;
              max-height: 192px;
              max-width: 192px;
              border-radius: 50%;
            "
            fit="fill"
            :src="shopInfo.logoPath"
            :preview-src-list="[shopInfo.logoPath]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <el-link
            style="height: 192px"
            class="edit-btn"
            @click="openDialog(operationType.editShopLogo)"
            :underline="false"
            type="primary"
          >
            修改
          </el-link>
          <!-- <img class="shop-logo" v-bind:src="shopInfo.logoPath" /> -->
          <el-divider></el-divider>
        </el-descriptions-item>
        <el-descriptions-item
          class="des-item"
          :label="shopOrStudioTag + '介绍'"
        >
          <span v-if="!shopInfo.intro">&nbsp;</span>
          <span v-html="shopInfo.intro"></span>
          <el-link
            class="edit-btn"
            @click="openDialog(operationType.editShopIntro)"
            :underline="false"
            type="primary"
          >
            修改
          </el-link>
          <el-divider></el-divider>
        </el-descriptions-item>
        <el-descriptions-item
          class="des-item"
          :label="shopOrStudioTag + '状态'"
        >
          <el-tag v-if="shopInfo.state" size="small">{{
            shopInfo.state === "试运营" || shopInfo.state === "营业中"
              ? `上线中`
              : `已下线`
          }}</el-tag>
          <el-tag v-else size="small">&nbsp;</el-tag>
          <el-divider></el-divider>
        </el-descriptions-item>
      </el-descriptions>
      <el-dialog
        id="z-dialog"
        width="28%"
        top="30vh"
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        @closed="closeDialog"
      >
        <el-form
          id="dialogForm"
          @submit.native.prevent
          :model="form"
          label-width="100px"
        >
          <el-form-item
            v-show="dialogTitle === operationType.editShopName"
            :label="shopOrStudioTag + '名称'"
            required
          >
            <el-input
              style="width: 300px; margin-left: 20px"
              v-model.trim="form.name"
              autocomplete="off"
              :placeholder="`请输入${shopOrStudioTag}名称`"
              maxlength="50"
              show-word-limit
            ></el-input>
            <div class="el-form-item__error" style="margin-left: 100px">
              {{ dialogErrorMsg }}
            </div>
          </el-form-item>
          <el-form-item
            v-show="dialogTitle === operationType.editShopLogo"
            :label="`${shopOrStudioTag}logo`"
            required
          >
            <span style="color: darkgray; margin-left: 20px; font-size: 12px"
              >尺寸192*192，格式为jpg、png，大小不超过2M</span
            >
            <br />
            <el-upload
              :auto-upload="true"
              accept=".png,.jpg"
              class="avatar-uploader"
              :action="uploadLogoUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeUpload"
            >
              <el-image v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="uploadSuccMsg !== ''"
              style="margin-left: 100px; color: green; line-height: 0"
            >
              {{ uploadSuccMsg }}
            </div>
            <div
              v-show="uploadErrorMsg !== ''"
              style="margin-left: 100px; color: red; line-height: 0"
            >
              {{ uploadErrorMsg }}
            </div>
          </el-form-item>
          <el-form-item
            id="shopIntroInput"
            v-show="dialogTitle === operationType.editShopIntro"
            :label="`${shopOrStudioTag}介绍`"
            required
          >
            <el-input
              resize="none"
              clearable
              style="width: 300px; margin-left: 20px; min-height: 100px"
              v-model.trim="form.intro"
              autocomplete="off"
              :placeholder="`请输入${shopOrStudioTag}介绍`"
              maxlength="100"
              show-word-limit
              type="textarea"
              rows="6"
            ></el-input>
            <div
              style="
                margin-left: 100px !important;
                word-wrap: break-word;
                width: 230px;
                display: inline-block;
                line-height: 15px !important;
                padding-top: 0;
                top: 150px;
              "
              class="el-form-item__error"
            >
              {{ dialogErrorMsg }}
            </div>
            <!--          <div-->
            <!--            style="-->
            <!--              font-size: 10px;-->
            <!--              color: rgb(128, 128, 128);-->
            <!--              height: 16px;-->
            <!--              margin-left: 350px;-->
            <!--            "-->
            <!--          >-->
            <!--            {{ form.intro.length }}/100-->
            <!--          </div>-->
          </el-form-item>
          <br />
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="okDialog"
            type="primary"
            :loading="dialogButtonLoading"
            :disabled="
              !(
                this.dialogTitle === this.operationType.editShopName &&
                this.form.name
              ) &&
              !(
                this.dialogTitle === this.operationType.editShopIntro &&
                this.form.intro
              ) &&
              !(
                this.dialogTitle === this.operationType.editShopLogo &&
                this.form.logoPath
              )
            "
            >确 定
          </el-button>
        </div>
      </el-dialog>
      <!--    <auth-dialog-->
      <!--        :dialog-visible.sync="auth.flag"-->
      <!--        :tip-type="auth.tipType"-->
      <!--    ></auth-dialog>-->
      <!-- <div class="item-name">店铺介绍：</div>
    <div class="item-value">{{ shopInfo.intro }}</div> -->
    </div>
    <h5 class="page-title" style="margin-top: 20px">
      {{ shopOrStudioTag }}小程序嵌入公众号
    </h5>
    <div class="store-info-box">
      <el-descriptions v-model="shopInfo" style="padding-top: 10px">
        <el-descriptions-item class="des-item" label="操作方法">
          <span style="opacity: 0">?</span>
          <el-link
            class="edit-btn"
            @click="operationMethodDialog = true"
            :underline="false"
            type="primary"
          >
            查看
          </el-link>
          <el-divider></el-divider>
        </el-descriptions-item>
        <el-descriptions-item class="des-item" label="AppId">
          wxe322a390c7367e9b
          <el-link
            class="edit-btn"
            @click="copy2Clipboard('wxe322a390c7367e9b')"
            :underline="false"
            type="primary"
          >
            复制
          </el-link>
          <el-divider></el-divider>
        </el-descriptions-item>
        <el-descriptions-item class="des-item" label="小程序路径">
          {{
            "packages/knowledgeStore/pages/detail/index?storeId=" +
            $store.state.user.userInfo.shopId
          }}
          <el-link
            class="edit-btn"
            @click="
              copy2Clipboard(
                `packages/knowledgeStore/pages/detail/index?storeId=` +
                  $store.state.user.userInfo.shopId
              )
            "
            :underline="false"
            type="primary"
          >
            复制
          </el-link>
          <el-divider></el-divider>
        </el-descriptions-item>
      </el-descriptions>
      <el-dialog
        title="操作方法"
        :visible.sync="operationMethodDialog"
        width="30%"
        top="25vh"
      >
        <span style="display: flex; justify-content: center; font-size: 15px"
          >根据提供的【Appld】 和【小程序路径】 将自己的{{
            shopOrStudioTag
          }}小程序插入在公众号中，引导公众号粉丝进入{{
            shopOrStudioTag
          }}小程序进行资源浏览和下载。
          <br />
          <br />
          该功能适用于拥有自己公众号且有一定粉丝基础的{{ shopOrStudioTag }}。
          <br />
          <br />
          1. 在公众号菜单栏插入{{ shopOrStudioTag }}小程序:
          公众号后台点击"自定义菜单"-设置菜单名
          称-菜单内容选择-跳转到小程序点击【选择小程序】
          -粘贴【小程序路径】-点击"保布并发布"。
          <br />
          <br />
          2. 在公众号文章中插入{{ shopOrStudioTag }}小程序:
          公众号后台新建图文消息-选择"小程序"-输
          入【Appld】-输入【小程序路径】，选择展现方式，点击"确定"。</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            size="small"
            @click="operationMethodDialog = false"
            >我知道了</el-button
          >
        </span>
      </el-dialog>
    </div>
    <auth-dialog
      :dialog-visible.sync="auth.flag"
      :tip-type="auth.tipType"
    ></auth-dialog>
  </div>
</template>
<script>
import api from "@/assets/js/api";
const clipboardy = require("clipboardy");

import AuthDialog from "@/components/auth-dialog.vue";
import { isOpenPermissionDialog } from "@/assets/js/utils";
import store from "@/store";

export default {
  components: { AuthDialog },
  data() {
    return {
      operationMethodDialog: false,
      logo: "https://materialresource.xkw.com/material/store/store_logo.png",
      auth: {
        flag: false,
        tipType: null,
      },
      fullscreenLoading: false,
      dialogButtonLoading: false,
      dialogFormVisible: false,
      operationType: {
        editShopName: `修改${store.getters["user/shopOrStudioTag"]}名称`,
        editShopLogo: `修改${store.getters["user/shopOrStudioTag"]}logo`,
        editShopIntro: `修改${store.getters["user/shopOrStudioTag"]}介绍`,
      },
      dialogTitle: "",
      dialogErrorMsg: "",
      coverDelDisabled: false,
      imgUrl: null,
      form: {
        id: this.$store.state.user.userInfo.shopId,
        name: null,
        intro: "",
        logoPath: null,
      },
      uploadLogoUrl: "",
      uploadErrorMsg: "",
      uploadSuccMsg: "",
      shopInfo: {
        id: "",
        logoPath: "",
        name: "",
        intro: "",
        state: "",
      },
      logoLabelStyle: {
        height: "192px",
        display: "flex",
        "align-items": "center",
      },
    };
  },
  computed: {
    shopOrStudioTag: () => {
      return store.getters["user/shopOrStudioTag"];
    },
  },
  created() {
    this.uploadLogoUrl = "https://shopcenter.xkw.com/" + api.info.uploadLogo;
    this.getShopInfo();
  },
  mounted() {},
  methods: {
    copy2Clipboard(text) {
      clipboardy.write(text);
      this.$message.success("复制成功");
    },
    handleAvatarSuccess(res, file) {
      this.imgUrl = URL.createObjectURL(file.raw);
      if (res.valid && res.result) {
        this.form.logoPath = res.result.placeholderFilePath;

        //$("#upload-pic .el-upload--picture-card").css({ display: "none" });
        //this.$message.success("上传成功");
        this.uploadSuccMsg = "上传成功";
        this.fullscreenLoading = false;
        return;
      } else if (res.error.status) {
        this.uploadErrorMsg = "图片包含敏感信息";
      } else {
        this.uploadErrorMsg = "上传失败";
      }
      this.imgUrl = null;
      this.form.logoPath = null;
      this.fullscreenLoading = false;
    },
    beforeUpload(file) {
      this.fullscreenLoading = true;
      this.uploadSuccMsg = "";
      this.uploadErrorMsg = "";
      let isOK =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      let isLt1M = file.size / 1024 / 1024 < 2;
      if (!isOK) {
        //this.$message.error("上传头像只支持JPG、PNG格式!");
        this.uploadErrorMsg = "尺寸192*192，格式为jpg、png";
        this.imgUrl = null;
        this.form.logoPath = null;
        this.fullscreenLoading = false;
        return false;
      }
      if (!isLt1M) {
        //this.$message.error("上传头像大小不能超过2MB!");
        this.uploadErrorMsg = "大小不超过2M";
        this.imgUrl = null;
        this.form.logoPath = null;
        this.fullscreenLoading = false;
        return false;
      }
      return isOK && isLt1M;
    },
    shopNameInput() {
      this.dialogErrorMsg = "";
    },
    openDialog(opt) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      this.dialogTitle = opt;
      switch (opt) {
        case this.operationType.editShopName:
          break;
        case this.operationType.editShopLogo:
          break;
        case this.operationType.editShopIntro:
          break;
      }
      this.dialogFormVisible = true;
    },
    async updateShopInfo(params) {
      this.dialogButtonLoading = true;
      this.dialogErrorMsg = "";
      const res = await this.$axios.post(api.info.updateShopInfo, params);
      if (!res.valid && res.error.message) {
        this.dialogErrorMsg = res.error.message;
      } else if (res.valid && res.result) {
        this.$message.success("修改成功");
        await this.getShopInfo();
        if (this.dialogTitle === this.operationType.editShopName) {
          //this.$store.state.user.userInfo.shopName = params.name;
          this.$store.commit("user/setShopName", params.name);
        }
        this.dialogFormVisible = false;
      } else {
        this.$message.error("修改失败");
      }
      this.dialogButtonLoading = false;
    },
    okDialog() {
      switch (this.dialogTitle) {
        case this.operationType.editShopName:
          this.updateShopInfo({
            id: this.form.id,
            name: this.form.name,
          });
          break;
        case this.operationType.editShopLogo:
          this.updateShopInfo({
            id: this.form.id,
            logoPath: this.form.logoPath,
          });
          break;
        case this.operationType.editShopIntro:
          this.updateShopInfo({
            id: this.form.id,
            intro: this.form.intro,
          });
          break;
      }
    },
    closeDialog() {
      this.form.name = null;
      this.form.intro = "";
      this.imgUrl = null;
      this.form.logoPath = null;
      this.dialogTitle = "";
      this.dialogErrorMsg = "";
      this.uploadSuccMsg = "";
      this.uploadErrorMsg = "";
      this.fullscreenLoading = false;
    },
    /*获取店铺信息*/
    async getShopInfo() {
      let shopId = this.$store.state.user.userInfo.shopId;
      const shopInfoResult = await this.$axios.post(
        api.info.getShopInfo + "?shopId=" + shopId
      );
      if (shopInfoResult.valid) {
        if (
          shopInfoResult.result.name == null ||
          shopInfoResult.result.name === "" ||
          shopInfoResult.result.name.length === 0 ||
          shopInfoResult.result.name === "未命名店铺"
        ) {
          shopInfoResult.result.name = "请尽快完善信息";
        }
        if (
          shopInfoResult.result.intro == null ||
          shopInfoResult.result.intro === "" ||
          shopInfoResult.result.intro.length === 0
        ) {
          shopInfoResult.result.intro = "请尽快完善信息";
        }
        if (
          shopInfoResult.result.logoPath == null ||
          shopInfoResult.result.logoPath.length === 0 ||
          shopInfoResult.result.logoPath === ""
        ) {
          shopInfoResult.result.logoPath = this.logo;
        }
        this.shopInfo = shopInfoResult.result;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-title {
  padding: 10px 10px 10px 0;
  color: #3a3d4b;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
}
::v-deep #shopIntroInput .el-input__count {
  line-height: 1;
}
::v-deep #shopIntroInput .el-form-item__label {
  line-height: 32px !important;
}
::v-deep #logoImg {
  min-height: 192px;
  min-width: 192px;
  max-height: 192px;
  max-width: 192px;
}
::v-deep #shopLogoLabel .el-descriptions-item__label {
  height: 192px;
  display: flex;
  align-items: center;
}

::v-deep.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader {
  //display: flex !important;
  //justify-content: center !important;
  margin-left: 100px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 192px;
  height: 192px;
  line-height: 192px;
  text-align: center;
}

.avatar {
  width: 192px;
  height: 192px;
  display: block;
}

::v-deep #z-dialog .el-dialog__body {
  padding-bottom: 0;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep #dialogForm .el-form-item__content {
  margin-left: 20px !important;
}

.edit-btn {
  float: right;
}

::v-deep .el-descriptions__body .el-descriptions-item__cell {
  padding-top: 0;
  padding-bottom: 0;
}

.info-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  /*background-color: #fff;*/
  padding: 20px;
  margin-bottom: 20px;
}

.shop-logo {
  height: 20px;
}

::v-deep .el-descriptions-item {
  display: block;
  padding: 10px;
}

$key-width: 80px;
::v-deep .el-descriptions-item__label {
  width: $key-width;
}

.des-item {
  padding: 10px;
}

::v-deep .el-descriptions-item__content {
  width: calc(100% - #{$key-width});
}

.store-info-box {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;

  .item-name {
    padding: 10px;
    width: 100px;
    float: left;
    clear: left;
  }

  .item-value {
    display: inline-block;
  }
}
</style>
